<template>
    <rkm-form
        v-if="loaded"
        ref="Form"
    >
        <rkm-row class="mt-2">
            <rkm-col>
                <Status :data="{ form: form.statusTipo, model }" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <Prioridade
                    :data="{ form: form.prioridadeTipo, model }"
                    :sla="model.sla"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <Sla
                    :data="{ form: form.prioridades, model }"
                    :prioridadeModal="model.prioridade"
                    :prioridadeOrinal="prioridadeOriginal"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>

// Components.
import Prioridade from './components/prioridade/Index'
import Sla from './components/sla/Index'
import Status from './components/status/Index'

// Mixins.
import { repository, error, object, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: {
        Prioridade,
        Sla,
        Status,
    },
    computed: {
        validations() {

            return {
                mensagemProtocoloSolicitacao: { max: 500 },
                mensagemComprovanteAgendamento: { max: 500 },
            }
        }
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('manutencao.parametrizacao'),
        }

        this.load()
    },
    data: () => ({
        form: null,
        loaded: false,
        model: null,
        prioridadeOriginal: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.parametrizacao.create()
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model
                    this.prioridadeOriginal = this.clone(data.model.prioridade)

                    this.$emit('data-load', { form: this.form, model: this.model })

                    this.loaded = true;
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.parametrizacao.store(this.prepareData())
                        .then(() => {

                            this.showSaveNotification()
                            this.$emit('save')
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const data = this.clone(this.model)

            data.status = data.status.map(status => ({
                id: status.id,
                tipoStatusId: status.tipoStatusId,
                nomeStatus: status.nomeStatus,
            }));

            data.prioridade = data.prioridade.map(prioridade => ({
                id: prioridade.id,
                tipoPrioridadeId: prioridade.tipoPrioridadeId,
                nomePrioridade: prioridade.nomePrioridade,
            }));
            data.sla = data.sla.map(sla => ({
                id: sla.id,
                prioridadeId: sla.prioridadeId,
                tempoDeAtendimento: sla.tempoDeAtendimento,
            }));

            return this.camelObjectKeysToSnakeRecursive(data)
        },
    },
    mixins: [repository, error, object, stringCase],
}
</script>